export default {
  title: 'Sei sicuro di voler uscire?',
  buttons: {
    logout: 'Esci',
    cancel: 'Annulla',
  },
};
